module.exports = __webpack_public_path__ + "static/media/LogoLight.c74b6855.png";